import { createSlice } from '@reduxjs/toolkit';
import { GemicroCode } from 'modules/types/GemicroCode';
import { fetchEntityAndBusinessTypes } from './thunks';

export interface EntityAndBusinessState {
  entityTypes?: GemicroCode[];
  businessTypes?: GemicroCode[];
  loading?: boolean;
  error?: string;
}

const initialState: EntityAndBusinessState = {
  entityTypes: undefined,
  businessTypes: undefined,
  loading: false,
  error: undefined,
};

export const entityAndBusinessSlice = createSlice({
  name: 'entityBusiness',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchEntityAndBusinessTypes.pending, (state) => {
      state.loading = true;
      state.entityTypes = initialState.entityTypes;
      state.businessTypes = initialState.businessTypes;
      state.error = initialState.error;
    });
    builder.addCase(fetchEntityAndBusinessTypes.fulfilled, (state, action) => {
      state.loading = false;
      state.entityTypes = action.payload.entityTypes;
      state.businessTypes = action.payload.businessTypes;
    });
    builder.addCase(fetchEntityAndBusinessTypes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload
        ? (action.payload as Error)?.message
        : action.error?.message;
    });
  },
});

export default entityAndBusinessSlice.reducer;
